// Honest, factual comparison copy. Every claim about a competitor here should
// be defensible if that competitor's own users read it — no invented stats,
// no trash talk. Avoid volatile pricing and plan-limit claims. Keep competitor
// summaries to a line; let the Quarkle column do the selling. No em dashes in
// user-visible copy.
export const COMPARISONS = [
  {
    slug: "sudowrite",
    name: "Sudowrite",
    dek: "the story-generation specialist",
    accent: "var(--pink)",
    summary: "Sudowrite is a drafting tool: beats and outlines in, prose out. Producing words is its lane.",
    metaDescription:
      "Compare Quarkle and Sudowrite for fiction drafting, editorial feedback, story context, continuity, and author control.",
    honestTake: {
      competitor: "Choose Sudowrite for beat-to-prose generation and faster drafting.",
      quarkle: "Choose Quarkle to edit, review, and continuity-check the book you're writing.",
    },
    rows: [
      ["what it's for", "turning beats and outlines into prose", "editing, reviewing, and continuity-checking the draft you're writing"],
      ["story context", "Story Bible fields and chapter links you maintain", "background agents build a Story Atlas from the manuscript and keep it current as you write"],
      ["editorial review", "rewrite and feedback tools", "12 specialist review passes, consolidated into google-docs style comments on your draft"],
      ["inline editing", "generated alternatives you swap in", "instant edit bar (expand, embellish, concise, restructure), every change previewed as a diff you accept or reject"],
    ],
  },
  {
    slug: "novelcrafter",
    name: "NovelCrafter",
    dek: "the worldbuilding database",
    accent: "var(--sky)",
    summary: "NovelCrafter pairs the Codex, a configurable story-bible database, with bring-your-own-key model access.",
    metaDescription:
      "Compare Quarkle and NovelCrafter for story memory, worldbuilding, AI editorial feedback, model access, and author control.",
    honestTake: {
      competitor: "Choose NovelCrafter for a configurable Codex and bring-your-own-model workflow.",
      quarkle: "Choose Quarkle for memory that builds itself and a full editorial review workflow.",
    },
    rows: [
      ["what it's for", "worldbuilding database + BYOK writing", "editing and reviewing with memory built in"],
      ["models", "bring your own API key and manage the billing", "frontier models built in with no keys; mature-fiction models flagged right in the picker"],
      ["story memory", "a Codex you configure and maintain", "Story Atlas notes built by background agents: versioned, and freezable to pin canon"],
      ["editorial review", "Workshop chat on demand", "12 specialist review passes, consolidated into comments on your draft, with every edit yours to accept or reject"],
    ],
  },
  {
    slug: "scrivener",
    name: "Scrivener",
    dek: "the structural incumbent",
    accent: "var(--clay)",
    summary: "Scrivener is the desktop standard for organizing and compiling long manuscripts. No AI, by design.",
    metaDescription:
      "Compare Quarkle and Scrivener for manuscript organization, AI editorial feedback, continuity, ownership, workflow, and author control.",
    honestTake: {
      competitor: "Choose Scrivener to organize, structure, and compile the manuscript itself.",
      quarkle: "Choose Quarkle for editorial feedback and continuity, or use both together.",
    },
    rows: [
      ["what it's for", "organizing and compiling a manuscript", "editorial feedback and continuity on one"],
      ["editorial review", "none, by design", "12 specialist review passes, consolidated into google-docs style comments on the draft"],
      ["story memory", "you track continuity yourself", "background agents keep Story Atlas notes current as the draft changes"],
      ["versioning", "manual snapshots", "auto-checkpoints about every 250 words, with word-level diffs and one-click restore"],
    ],
  },
  {
    slug: "novelai",
    name: "NovelAI",
    dek: "the generation & roleplay engine",
    accent: "var(--moss)",
    summary: "NovelAI generates stories and roleplay: text, images, and voice, steered by lore you curate.",
    metaDescription:
      "Compare Quarkle and NovelAI for fiction generation, editorial feedback, long-story memory, context limits, and author control.",
    honestTake: {
      competitor: "Choose NovelAI to generate stories, roleplay, images, and audio.",
      quarkle: "Choose Quarkle to edit an existing manuscript and track its continuity.",
    },
    rows: [
      ["what it's for", "generating story and roleplay text, images, and audio", "editing and continuity-checking a manuscript"],
      ["memory", "a context window sized by tier, plus a Lorebook you curate", "Story Atlas notes built by background agents: memory that grows with the book, not a window"],
      ["mature content", "permissive generation is a core draw", "mature-fiction models available after age confirmation, flagged in the model picker"],
      ["editorial review", "not the focus", "12 specialist review passes, consolidated into comments, with every edit yours to accept or reject"],
    ],
  },
];

export function getComparison(slug) {
  return COMPARISONS.find((c) => c.slug === slug) || null;
}
